import { useEffect, useState } from "react"
import { arrowLeft, logo, unView, view } from "../assets/images/images"
import CheckInput from "../assets/images/CheckInput"
import { useLocation, useNavigate } from "react-router-dom";
import { validateEmail, validatePassword } from "../share/validation";
import { resetPasword, resetPaswordConfirm } from "../services/api/auth.service";
import { publish } from "../services/loadingServices/loading.service";
import { showApiError } from "../services/apiError";
import BackIcon from "../assets/images/BackIcon";

const ForgotPassword = () => {
    const nav = useNavigate();
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);

    const [showPassword, setShowPassword] = useState<{ password: boolean; confirmPassword: boolean; }>({
        password: false,
        confirmPassword: false,
    });
    const location = useLocation();
    const [message, setMessage] = useState("")
    const [step, setStep] = useState<string>("1");
    const [errors, setErrors] = useState({
        email: "",
        password: "",
        confirmPassword: "",
    })
    const [formValues, setFormValues] = useState({
        password: "",
        email: "",
        confirmPassword: "",
    });
    const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
        const { name, value, type } = e.target;
        setFormValues(prev => ({ ...prev, [name]: value.trim() }));
        if (name === 'email') {
            if (!value) {
                setErrors(prev => ({ ...prev, email: 'Email is required' }));
            } else if (!validateEmail(value)) {
                setErrors(prev => ({ ...prev, email: 'Please enter a valid email address' }));
            } else {
                setErrors(prev => ({ ...prev, email: '' }));
            }
        }
        if (name === 'password') {
            const passwordError = validatePassword(value);
            setErrors(prev => ({ ...prev, password: passwordError }));
        }

        if (name === 'confirmPassword' || name === 'password') {
            const passwordValue = name === 'password' ? value : formValues.password;
            const confirmValue = name === 'confirmPassword' ? value : formValues.confirmPassword;
            if (confirmValue && passwordValue !== confirmValue) {
                setErrors(prev => ({ ...prev, confirmPassword: 'Passwords do not match' }));
            } else {
                setErrors(prev => ({ ...prev, confirmPassword: '' }));
            }
        }
    };
    const isFormStepOne = () => {
        const { email } = formValues;
        return email && !errors.email;
    };
    const isFormStepTwo = () => {
        const { password, confirmPassword } = formValues;
        return password && confirmPassword && validatePassword(password) === '' && !errors.password && !errors.confirmPassword && password === confirmPassword;
    };

    const handleSubmitStepOne = async (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        publish('loading', true);
        try {
            const response = await resetPasword({ email: formValues?.email || "" });
            if (response.data.success) {
                publish('loading', false);
                setMessage("Email verification sented, please check email !")
            }
        } catch (error: any) {
            publish('loading', false);
            showApiError(error, { language: window.languageContext?.language, setFieldErrors: (fe) => setErrors((prev: any) => ({ ...prev, ...fe })) });
        }
    }
    const handleSubmitStepTwo = async (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        try {
            const payload = {
                token: location?.search.split("?token=")[1],
                newPassword: formValues?.password
            }
            const response = await resetPaswordConfirm(payload);
            if (response.data.success) {
                setShowSuccessPopup(true)
            }
        } catch (error: any) {
            showApiError(error, { language: window.languageContext?.language, setFieldErrors: (fe) => setErrors((prev: any) => ({ ...prev, ...fe })), fieldAliases: { newPassword: "password" } });
        }
    }

    useEffect(() => {
        if (location?.search.includes("?token=")) {
            const token = location.search.split("?token=")[1];
            if (token && token.length > 0) {
                setStep("2");
            }
        }
    }, [])

    return (
        <>
            {/* Container chính - flex column để chia layout */}
            <div className="min-h-screen flex flex-col py-16">
                {/* Logo ở trên cùng */}
                <div className="">
                    <img src={logo} className="" />
                </div>

                {/* Content form căn giữa */}
                <div className="flex-1 flex items-center justify-center">
                    <div className="w-full">
                        {step === "1" ?
                            <form className="w-full space-y-10" onSubmit={(e: any) => handleSubmitStepOne(e)}>
                                <div className="space-y-3">
                                    <p className="text-[32px] text-[#05292A] font-medium">Reset your password</p>
                                    <p className="text-[14px] text-[#4A5353] font-medium">Enter your email address, and we'll send you a link to reset your password</p>
                                </div>
                                <div className="w-full space-y-2">
                                    <p className="text-[14px] text-[#222525] font-medium font-inter no-select">Email address</p>
                                    <input
                                        name="email"
                                        required
                                        value={formValues.email}
                                        onChange={handleChange}
                                        className={`text-[18px] placeholder:text-subtitle text-main font-bold border px-[14px] py-[10px]  rounded-xl outline-none focus-none bg-transparent w-full ${errors?.email.length ? "border-[#E40F03]" : "border-[#DBE4E4]"} `}
                                    />
                                    {errors?.email.length > 0 && <p className="text-[12px] font-bold text-[#E40F03] ">{errors?.email}</p>}
                                    {message.length > 0 && <p className="text-[12px] font-bold text-[#E40F03] ">{message}</p>}
                                </div>
                                <button type="submit" disabled={!isFormStepOne()} className={`w-full h-10 text-sm font-medium flex items-center justify-center rounded-[30px] ${isFormStepOne() ? "bg-[#0F7679] text-white" : "bg-[#F8F8F8] text-[#C9D7D8]"}`}>
                                    Reset password
                                </button>
                            </form>
                            :
                            <form className="w-full space-y-8" onSubmit={(e: any) => handleSubmitStepTwo(e)}>
                                <div className="space-y-4">
                                    <p className="text-[24px] text-main font-bold">Forgot Password?</p>
                                    <p className="text-[18px] text-main font-bold">Enter the email address you used when you joined and we'll send you instructions to reset your password.</p>
                                </div>
                                <div className="w-full space-y-2">
                                    <p className="text-[18px] text-main font-bold no-select">Password</p>
                                    <div className="relative">
                                        <input
                                            name="password"
                                            value={formValues.password}
                                            onChange={handleChange}
                                            type={showPassword.password ? "text" : "password"}
                                            className="text-[18px] placeholder:text-subtitle text-main font-bold border border-[#DBE4E4] px-[14px] py-[10px] rounded-xl outline-none focus-none bg-transparent w-full"
                                        />
                                        <div className="absolute top-1/2 -translate-y-1/2 right-4">
                                            <img
                                                src={showPassword.password ? unView : view}
                                                className="w-6 aspect-square cursor-pointer"
                                                onClick={() => { setShowPassword({ ...showPassword, password: !showPassword.password }) }}
                                            />
                                        </div>
                                    </div>
                                    {errors?.password.length > 0 && <p className="text-base font-bold text-[#E40F03] ">{errors?.password}</p>}
                                </div>
                                <div className="w-full space-y-2">
                                    <p className="text-[18px] text-main font-bold no-select">Confirm Password</p>
                                    <div className="relative">
                                        <input
                                            name="confirmPassword"
                                            value={formValues.confirmPassword}
                                            onChange={handleChange}
                                            type={showPassword.confirmPassword ? "text" : "password"}
                                            className={`text-[18px] placeholder:text-subtitle text-main font-bold border  px-[14px] py-[10px]  rounded-xl outline-none focus-none bg-transparent w-full ${errors?.confirmPassword.length ? "border-[#E40F03]" : "border-[#DBE4E4]"} `}
                                        />
                                        <div className="absolute top-1/2 -translate-y-1/2 right-4">
                                            <img
                                                src={showPassword.confirmPassword ? unView : view}
                                                className="w-6 aspect-square cursor-pointer"
                                                onClick={() => { setShowPassword({ ...showPassword, confirmPassword: !showPassword.confirmPassword }) }}
                                            />
                                        </div>
                                    </div>
                                    {errors?.confirmPassword.length > 0 && <p className="text-base font-bold text-[#E40F03] ">{errors?.confirmPassword}</p>}
                                </div>
                                <button disabled={!isFormStepTwo()} className={`w-full h-10 text-sm font-medium flex items-center justify-center rounded-[30px ${isFormStepTwo() ? "bg-[#3ABFC3] text-main" : "bg-[#D8F2F2] text-[#C6C6C6]"}`}>
                                    Reset password
                                </button>
                            </form>
                        }
                    </div>
                </div>

                {/* Back to sign in ở dưới cùng */}
                <div className="flex items-center cursor-pointer" onClick={() => { nav('/login') }}>
                    <div className="w-6 h-6 flex items-center justify-center ">
                        <BackIcon />
                    </div>
                    <p
                        style={{ fontSize: '14px', fontWeight: '400', lineHeight: '28px', color: '#222525' }}
                        className="font-inter"
                    >
                        Back to sign in
                    </p>
                </div>
            </div>
            {
                showSuccessPopup && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full mx-4">
                            <h2 className="text-2xl font-bold text-main mb-4">Success!</h2>
                            <p className="text-main mb-6">Your passsword has been reset successfully.</p>
                            <button
                                onClick={() => nav('/login')}
                                className="w-full bg-[#3ABFC3] text-main font-bold py-3 rounded-xl"
                            >
                                Continue to Sign in
                            </button>
                        </div>
                    </div>
                )
            }
        </>
    )
}
export default ForgotPassword